/**
 * Map inventory product / variation fields to invoice line-item rate, discount %, and tax %.
 * Rate uses MRP (originalPrice or variation price); discount is always expressed as a percentage.
 */

function toDisplayNumber(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return "";
  return String(n);
}

export function discountPercentFromInventory({
  discount_type,
  discount_price,
  discount_percentage,
  mrp,
}) {
  const base = Number(mrp) || 0;
  const type = discount_type || "price";

  if (type === "percentage") {
    const pct = Number(discount_percentage);
    if (!Number.isFinite(pct) || pct <= 0) return "";
    return parseFloat(pct.toFixed(2));
  }

  const amount = Number(discount_price);
  if (!Number.isFinite(amount) || amount <= 0 || base <= 0) return "";
  return parseFloat(((amount / base) * 100).toFixed(2));
}

export function pricingFromInventory(source, taxSource = source) {
  const mrp =
    Number(
      source?.originalPrice ??
        source?.price ??
        source?.regularPrice ??
        0
    ) || 0;

  const rate = toDisplayNumber(mrp);
  const discountValue = discountPercentFromInventory({
    discount_type: source?.discount_type,
    discount_price: source?.discount_price,
    discount_percentage: source?.discount_percentage,
    mrp,
  });
  const discount = discountValue === "" ? "" : String(discountValue);

  const taxPct = Number(taxSource?.gst_percentage);
  const tax = Number.isFinite(taxPct) && taxPct > 0 ? String(taxPct) : "";

  return { rate, discount, tax };
}

export function pricingFromProduct(product) {
  return pricingFromInventory(product, product);
}

export function pricingFromVariation(variation, parentProduct) {
  return pricingFromInventory(variation, parentProduct);
}
